// extracted by mini-css-extract-plugin
export default {"background":"VideoModal_background__7sQb6","modal":"VideoModal_modal__E83hX","viddo_modal":"VideoModal_viddo_modal__Wbqf6","btn_main":"VideoModal_btn_main__uJXUZ"};